// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3H9vS","approved":"Status_approved__1F_V5","rejected":"Status_rejected__1fk8I","expired":"Status_expired__1wmTv","label":"Status_label__1J_V0"};